import React from 'react';
import Footer from './components/Footer';
import Main from './components/Main';

export default function TfpV2() {
  return (
    <>
      <Main />
      <Footer />
    </>
  );
}
